// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"533d6289","535":"6273ecc9","787":"60ce267c","952":"1e473d43"}[chunkId] + ".chunk.js";
};